import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';

@Component({
    selector: 'app-display-consent-footer',
    templateUrl: './display-consent-footer.component.html',
    styleUrls: ['./display-consent-footer.component.scss']
})
export class DisplayConsentFooterComponent implements OnChanges, AfterViewInit {
    @ViewChild('continueInFocus', {static: false}) continueElementFocus: ElementRef;
    @Input() moveToText: string | undefined;
    @Input() moreButton: boolean | undefined;
    @Input() disableSkip: OutlineUnitBasicModel[] | undefined;
    @Input() disableNext: boolean | undefined;
    @Input() isAudioMode: boolean;
    @Output() emitButtonClick: EventEmitter<string> = new EventEmitter<string>();
    moreButtonDisabled = false;

    constructor(private cdr: ChangeDetectorRef) {
    }

    onBtnClick(clickedBtn: string): void {
        this.emitButtonClick.emit(clickedBtn);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.cdr.detectChanges();
        this.moreButtonDisabled = !!this.moreButton;
    }

    ngAfterViewInit(): void {
        if (this.isAudioMode) {
            this.continueElementFocus.nativeElement.querySelector('button').focus();
        }
    }
}
